import { render, staticRenderFns } from "./TestPassage.vue?vue&type=template&id=2b547eff&scoped=true&"
import script from "./TestPassage.vue?vue&type=script&lang=js&"
export * from "./TestPassage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b547eff",
  null
  
)

export default component.exports